define(["dojo/i18n", "/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js"
,"/node_modules/dijit/nls/bs/loading.js?absMid=dijit/nls/bs/loading"
,"/node_modules/dijit/nls/mk/loading.js?absMid=dijit/nls/mk/loading"
,"/node_modules/dijit/nls/sr/loading.js?absMid=dijit/nls/sr/loading"
,"/node_modules/dijit/nls/zh/loading.js?absMid=dijit/nls/zh/loading"
,"/node_modules/dijit/nls/zh-tw/loading.js?absMid=dijit/nls/zh-tw/loading"
,"/node_modules/dijit/nls/vi/loading.js?absMid=dijit/nls/vi/loading"
,"/node_modules/dijit/nls/uk/loading.js?absMid=dijit/nls/uk/loading"
,"/node_modules/dijit/nls/tr/loading.js?absMid=dijit/nls/tr/loading"
,"/node_modules/dijit/nls/th/loading.js?absMid=dijit/nls/th/loading"
,"/node_modules/dijit/nls/sv/loading.js?absMid=dijit/nls/sv/loading"
,"/node_modules/dijit/nls/sl/loading.js?absMid=dijit/nls/sl/loading"
,"/node_modules/dijit/nls/sk/loading.js?absMid=dijit/nls/sk/loading"
,"/node_modules/dijit/nls/ru/loading.js?absMid=dijit/nls/ru/loading"
,"/node_modules/dijit/nls/ro/loading.js?absMid=dijit/nls/ro/loading"
,"/node_modules/dijit/nls/pt/loading.js?absMid=dijit/nls/pt/loading"
,"/node_modules/dijit/nls/pt-pt/loading.js?absMid=dijit/nls/pt-pt/loading"
,"/node_modules/dijit/nls/pl/loading.js?absMid=dijit/nls/pl/loading"
,"/node_modules/dijit/nls/nl/loading.js?absMid=dijit/nls/nl/loading"
,"/node_modules/dijit/nls/nb/loading.js?absMid=dijit/nls/nb/loading"
,"/node_modules/dijit/nls/lv/loading.js?absMid=dijit/nls/lv/loading"
,"/node_modules/dijit/nls/lt/loading.js?absMid=dijit/nls/lt/loading"
,"/node_modules/dijit/nls/ko/loading.js?absMid=dijit/nls/ko/loading"
,"/node_modules/dijit/nls/kk/loading.js?absMid=dijit/nls/kk/loading"
,"/node_modules/dijit/nls/ja/loading.js?absMid=dijit/nls/ja/loading"
,"/node_modules/dijit/nls/it/loading.js?absMid=dijit/nls/it/loading"
,"/node_modules/dijit/nls/id/loading.js?absMid=dijit/nls/id/loading"
,"/node_modules/dijit/nls/hu/loading.js?absMid=dijit/nls/hu/loading"
,"/node_modules/dijit/nls/hr/loading.js?absMid=dijit/nls/hr/loading"
,"/node_modules/dijit/nls/hi/loading.js?absMid=dijit/nls/hi/loading"
,"/node_modules/dijit/nls/he/loading.js?absMid=dijit/nls/he/loading"
,"/node_modules/dijit/nls/fr/loading.js?absMid=dijit/nls/fr/loading"
,"/node_modules/dijit/nls/fi/loading.js?absMid=dijit/nls/fi/loading"
,"/node_modules/dijit/nls/eu/loading.js?absMid=dijit/nls/eu/loading"
,"/node_modules/dijit/nls/et/loading.js?absMid=dijit/nls/et/loading"
,"/node_modules/dijit/nls/es/loading.js?absMid=dijit/nls/es/loading"
,"/node_modules/dijit/nls/el/loading.js?absMid=dijit/nls/el/loading"
,"/node_modules/dijit/nls/de/loading.js?absMid=dijit/nls/de/loading"
,"/node_modules/dijit/nls/da/loading.js?absMid=dijit/nls/da/loading"
,"/node_modules/dijit/nls/cs/loading.js?absMid=dijit/nls/cs/loading"
,"/node_modules/dijit/nls/ca/loading.js?absMid=dijit/nls/ca/loading"
,"/node_modules/dijit/nls/bg/loading.js?absMid=dijit/nls/bg/loading"
,"/node_modules/dijit/nls/az/loading.js?absMid=dijit/nls/az/loading"
,"/node_modules/dijit/nls/ar/loading.js?absMid=dijit/nls/ar/loading"
,"/node_modules/dijit/nls/loading.js?absMid=dijit/nls/loading"
], function(loader, runner) {
   return runner(loader, "dijit/nls/loading", __webpack_require__.dj.c(), false);
});